import React, { Component } from 'react'
import Loader from './../utils/Loader'
import Lightbox from 'react-image-lightbox'

import './../../css/product-image.css'

export default class ProductImages extends Component {

	constructor(props){
		super(props)
		this.state = {
			images: this.props.images ? this.props.images : [],
			photoIndex: 0,
			isLightboxOpen: false
		}
	}

	componentWillReceiveProps(nextProps) {
		// When receiving new images, make sure we reset to first image
		this.setState({
			images: nextProps.images,
			photoIndex: 0,
			isLightboxOpen: false
		})
	}

	showImage(){

		// ===================================
		//	Images available
		// ===================================
		if(this.props.images && this.props.images.length){

			const img = this.state.images[this.state.photoIndex]
			const nextSrc = this.state.images.length > 1 ? this.state.images[(this.state.photoIndex + 1) % this.state.images.length].img : undefined
			const prevSrc = this.state.images.length > 1 ? this.state.images[(this.state.photoIndex + this.state.images.length - 1) % this.state.images.length].img : undefined

			// console.log(prevSrc)

			return (
				<div>
					{/* Lightbox */}
					{this.state.isLightboxOpen &&
						<Lightbox
							mainSrc={img.img}
							nextSrc={nextSrc}
							prevSrc={prevSrc}
							onCloseRequest = { () => this.setState({ isLightboxOpen: false }) }
							onMovePrevRequest = { () => this.setState({
								photoIndex: (this.state.photoIndex + this.state.images.length - 1) % this.state.images.length,
							})}
							onMoveNextRequest = { () => this.setState({
								photoIndex: (this.state.photoIndex + 1) % this.state.images.length,
							})}
						/>
					}

					{/* Large image */}
					<div className="main_img">
						<div className="display_img" onClick={() => this.setState({ isLightboxOpen: true })}>
							<img src={img.sizes.preview.src} alt={img.alt} />
						</div>
					</div>

					{/* Enlarge btn */}
					<div className="product_image_options">
						<div className="enlarge" onClick={() => this.setState({ isLightboxOpen: true })}>
							Click to enlarge
						</div>
					</div>

					{/* Thumbnails */}
					<div className="thumbnail_collection">
						{this.props.images.map((image, i) => {
							let clName = 'thumbnail'
							
							if(i === this.state.photoIndex){
								clName += ' active'
							}

							return <img key={i} className={clName} src={image.sizes.preview.src} data-large={image.img} alt={image.alt} onClick={() => this.setState({ photoIndex: i })} />
						})}
					</div>
				</div>
			)

		// ===================================
		//	No product images
		// ===================================
		}else{

			// Loading image
			let dimensions = { width: 360, height: 360 }
			let img = <Loader height={dimensions.height} width={dimensions.width} />

			// 'No product image' is available
			if(!this.props.product.isLoading && this.props.siteInfo.site){
				img = <img src={this.props.siteInfo.site.no_product_img} alt={this.props.siteInfo.site.title} />
			}

			return (
				<div className="main_img">
					{img}
				</div>
			)
		}
	}

	render() {
		return (
			<div className="product_image_section">
				{this.showImage()}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/product/ProductImages.js